import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getUserDetailFetchSuccess,
    getUserDetailFetchFailure,
    createUserDetailFetchSuccess,
    createUserDetailFetchFailure,
    updateUserDetailFetchSuccess,
    updateUserDetailFetchFailure,
} from './reducer';
import { getUsersListFetch } from 'src/resources/usersList/reducer';
import { UserDetailResType } from 'src/types/userDetail';
import { UserType } from 'src/types/user';
import translate from '@translate';

const getUserDetailFetchRequest = async (idUser: string) => {
    const res = await api('get', `api/secure/users/${idUser}`);
    return res.data;
};

function* getUserDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: UserDetailResType = yield call((): any => getUserDetailFetchRequest(action.payload));
        yield put(getUserDetailFetchSuccess(response));
    } catch (error) {
        yield put(getUserDetailFetchFailure({ error }));
    }
}

export function* getUserDetailFetchWatch() {
    yield takeEvery('userDetail/getUserDetailFetch', getUserDetailFetch);
}

const createUserDetailFetchRequest = async (data: UserType) => {
    const res = await api('post', 'api/secure/users', data);
    return res.data;
};

interface CreateUserDetailResType {
    message: string;
    data: UserType;
}

function* createUserDetailFetch(action: { type: string; payload: UserType }) {
    try {
        const response: CreateUserDetailResType = yield call((): any => createUserDetailFetchRequest(action.payload));
        yield put(
            createUserDetailFetchSuccess({
                ...response.data,
                messageSuccess: { title: translate('users.message.userCreated') },
            })
        );
        yield put(getUsersListFetch());
    } catch (error) {
        yield put(createUserDetailFetchFailure({ error }));
    }
}

export function* createUserDetailFetchWatch() {
    yield takeEvery('userDetail/createUserDetailFetch', createUserDetailFetch);
}

const updateUserDetailFetchRequest = async (params: { idUser: string; data: UserType }) => {
    const res = await api('put', `api/secure/users/${params.idUser}`, params.data);
    return res.data;
};

function* updateUserDetailFetch(action: { type: string; payload: { idUser: string; data: UserType } }) {
    try {
        const response: UserDetailResType = yield call((): any => updateUserDetailFetchRequest(action.payload));
        yield put(
            updateUserDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('users.message.userUpdate') },
            })
        );
        yield put(getUsersListFetch());
    } catch (error) {
        yield put(updateUserDetailFetchFailure({ error }));
    }
}

export function* updateUserDetailFetchWatch() {
    yield takeEvery('userDetail/updateUserDetailFetch', updateUserDetailFetch);
}
